import { render, staticRenderFns } from "./ProductSpecificationImages.vue?vue&type=template&id=307bf35e&scoped=true&"
import script from "./ProductSpecificationImages.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationImages.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/ProductSpecificationImages/ProductSpecificationImagesStyle.css?vue&type=style&index=0&id=307bf35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307bf35e",
  null
  
)

export default component.exports